import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import AdminService from '@/services/admin.service';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/RequestChanges.css';

function RequestChangesModalContent({ close, draftId }) {
  const { cacheHandler } = useStateHandler();
  const [requestReason, setRequestReason] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function requestArtworkRequest() {
    setLoading(true);

    if(!requestReason) {
      alert("Introduce the reason, please.");
      setLoading(false);
      return;
    }

    const { response } = await AdminService.requestChangesArtworkRequestAndNotifyChanges(draftId, requestReason);

    setLoading(false);

    if(response.ok) {
      alert("Change requests have been saved successfully.");
      cacheHandler.triggerAction("ARTWORK_CHANGES_REQUEST");
      navigate("/admin/artwork-requests", { replace: true });
    } else {
      alert("Something went wrong, please try again later.");
    }
  }

  return (
    <>
      <Text
        className="admin-request-artwork-modal__text font-size-small"
        paragraph
        justify>
        Next, specify to the gallery the reasons why your work has been rejected. The gallery will be notified both by email and through the "Changes required" section.
      </Text>
      <PublicFormInput
        placeholder='Changes requested'
        className="admin-request-artwork-modal__textarea"
        type="textarea"
        value={requestReason}
        onChange={e => setRequestReason(e.target.value)}
      />
      <div className="admin-request-artwork-modal__options element-non-selectable">
        <Text
          className="admin-request-artwork-modal__option cancel font-size-small"
          onClick={close}>
                    Cancel
        </Text>

        <Text
          className={[
            `admin-request-artwork-modal__option request ${loading ? "read-only" : ""}`,
            "font-size-small"
          ].filter(Boolean).join(" ")}
          onClick={requestArtworkRequest}>
          {loading ? "Loading..." : "Request changes"}
        </Text>
      </div>
    </>
  );
}

export default function RequestChangesModal({ open, close, draftId }) {
  return (
    <>
      <GenericPopup open={open} className="admin-request-artwork-modal" opacity>
        <RequestChangesModalContent close={close} draftId={draftId}/>
      </GenericPopup>
    </>
  );
}
